var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboPlayCircleSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.33333C11.1267 2.33333 13.6667 4.87333 13.6667 8C13.6667 11.1267 11.1267 13.6667 8 13.6667C4.87333 13.6667 2.33333 11.1267 2.33333 8C2.33333 4.87333 4.87333 2.33333 8 2.33333ZM8 1C4.13333 1 1 4.13333 1 8C1 11.8667 4.13333 15 8 15C11.8667 15 15 11.8667 15 8C15 4.13333 11.8667 1 8 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3336V4.75364C6 4.49364 6.28 4.33364 6.5 4.46697L11.4333 7.34697C11.64 7.46697 11.6533 7.7603 11.4667 7.9003L6.53333 11.6003C6.31333 11.767 6 11.607 6 11.3336ZM7.33333 6.49364V9.33364L9.46 7.73364L7.33333 6.49364Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboPlayCircleSmall);
export default __webpack_public_path__ + "static/media/FBOPlayCircleSmall.9d19effd52da31f4504dc1e9a54b5b70.svg";
export { ForwardRef as ReactComponent };